import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { IconButton, Tooltip } from '@mui/material';

const InfoButton = ({ tooltipText }) => {
  return (
    <Tooltip title={tooltipText} arrow placement="top">
      <IconButton size="large" sx={{ ml: 1 }}>
        <InfoOutlinedIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};

export default InfoButton;